import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, HeartPulse } from "lucide-react";
import { logAttribution } from "@/lib/tracking";

const BOOKINGS = [
  { name: "Patricia", city: "Naples", service: "Companion Care", mins: 3 },
  { name: "Robert", city: "Fort Myers", service: "Alzheimer's Care", mins: 7 },
  { name: "Linda", city: "Bonita Springs", service: "Personal Care", mins: 12 },
  { name: "William", city: "Cape Coral", service: "24-hour Live-in Care", mins: 18 },
  { name: "Susan", city: "Marco Island", service: "Companion Care", mins: 24 },
  { name: "James", city: "Estero", service: "Medication Reminders", mins: 31 },
  { name: "Barbara", city: "Naples", service: "Meal Preparation", mins: 42 },
  { name: "Richard", city: "Fort Myers", service: "Dementia Care", mins: 55 },
  { name: "Mary", city: "Bonita Springs", service: "Respite Care", mins: 68 },
  { name: "Charles", city: "Naples", service: "Transportation", mins: 83 },
  { name: "Dorothy", city: "Cape Coral", service: "Overnight Care", mins: 97 },
  { name: "Thomas", city: "Marco Island", service: "Light Housekeeping", mins: 112 },
];

export default function SocialProofToast() {
  const [open, setOpen] = useState(false);
  const [idx, setIdx] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;
    const first = setTimeout(() => setOpen(true), 15000);
    const rotate = setInterval(() => {
      setIdx((i) => (i + 1) % BOOKINGS.length);
    }, 20000);
    return () => {
      clearTimeout(first);
      clearInterval(rotate);
    };
  }, [dismissed]);

  if (!open || dismissed) return null;
  const b = BOOKINGS[idx];
  return (
    <div
      data-testid="social-proof-toast"
      className="fixed bottom-24 lg:bottom-6 left-4 md:left-6 z-30 max-w-xs rounded-2xl bg-white border border-navy-900/10 shadow-xl p-4 pr-9 animate-fade-up"
    >
      <button
        type="button"
        onClick={() => setDismissed(true)}
        data-testid="social-proof-close"
        className="absolute top-2 right-2 text-navy-400 hover:text-navy-900"
        aria-label="Close"
      >
        <X className="h-4 w-4" />
      </button>
      <div className="flex items-start gap-3">
        <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold-100 text-gold-600">
          <HeartPulse className="h-4 w-4" strokeWidth={1.75} />
        </span>
        <div>
          <Link
            to="/contact"
            onClick={() => logAttribution("social_proof_toast")}
            className="block text-sm text-navy-900 hover:text-gold-600 transition-colors"
            data-testid="social-proof-cta"
          >
            <span className="font-medium">{b.name}</span> in {b.city} just
            scheduled <span className="font-medium">{b.service}</span>
            <span className="block text-xs text-navy-500 mt-0.5">
              {b.mins} min ago
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
}
